import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { IPartner } from '@/modules/partner/model';
import { namespace } from '@/modules/partner/namespace';
import { getUserData } from '@/modules/user/store/selectors';
import { RootState } from '@/root-store';

import { setPartner } from '../actions';

const loadPartner = createAsyncThunk(
  `${namespace}/load-partner`,
  async (_, { dispatch, getState }): Promise<IPartner> => {
    const me = getUserData(getState() as RootState);

    const partner = await partnerAPI.readPartner(me);

    dispatch(setPartner(partner));

    return partner;
  },
);

export { loadPartner };
